var map = {
	"./en-us.yaml": 27789
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 7 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 41517;
module.exports = webpackAsyncContext;